const obj = {
  id: 0,
  fieldId: 0,
  value: ''
}

export default function AdminConfigModel(params = obj) {
  return {
    ...obj,
    ...params,
  };
}
